module.filter('phone', function() {
    return function(phone) {
        if (!phone) return phone;

        if (phone.length == 10) {
            return [phone.substring(0, 3),
                            phone.substring(3, 6),
                            phone.substring(6, 10)].join('-');
        } else if (phone[0] != "+") {
            return [phone.substring(0, 3),
                            phone.substring(3, 6),
                            phone.substring(6, 10)].join('-') +
                            " x" + phone.substring(10);
        }
        return phone;
    };
});